module.exports = __webpack_public_path__ + "static/media/wonde-logo2.d49e14aa.png";